import { useTheme } from "@mui/material";
import { ArrowDown2, ArrowRight2, CloseCircle, Edit2 } from "iconsax-react";
import React from "react";

import Tooltip from "@SonarCX/components/atoms/Tooltip";
import { useAppSelector } from "@SonarCX/hooks/redux";
import useAccess, { PERMS } from "@SonarCX/hooks/useAccess";
import { useAreYouSure } from "@SonarCX/providers/AreYouSureProvider";
import { useSupabase } from "@SonarCX/providers/SupabaseProvider";
import { TaskCategoryRule } from "@SonarCX/providers/SupabaseProvider/hooks/useTaskCategoryRules";
import { selectCategory } from "@SonarCX/slices/category";
import { selectTaskType } from "@SonarCX/slices/taskType";
import useStyles from "./styles";

type Props = {
  rule: TaskCategoryRule;
  onClickEdit: () => void;
};

const CategoryRule: React.FC<Props> = ({ rule, onClickEdit }) => {
  const theme = useTheme();
  const { categories } = useAppSelector(selectCategory);
  const { types } = useAppSelector(selectTaskType);
  const hasPermission = useAccess();
  const {
    taskCategoryRules: { deleteRule },
  } = useSupabase();
  const { setAction, setReason, setSubtext, setTitle, setV2 } = useAreYouSure();

  const [expanded, setExpanded] = React.useState(false);

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Tooltip
          arrow
          title={expanded ? "Hide Types" : "Show Types"}
          placement="top"
        >
          <div
            onClick={() => setExpanded((expanded) => !expanded)}
            className={classes.toggle}
          >
            {expanded ? (
              <ArrowDown2 size={theme.size.sm} variant="Bold" />
            ) : (
              <ArrowRight2 size={theme.size.sm} variant="Bold" />
            )}
          </div>
        </Tooltip>

        <div>
          {categories[rule.task_category_id]?.name || "Unknown Category"}
          {" - "}
          {rule.task_type_ids.length} type
          {rule.task_type_ids.length !== 1 && "s"}
        </div>

        {hasPermission([PERMS.TasksAdmin]) && (
          <Edit2
            size={theme.size.sm}
            className={classes.clickable}
            onClick={onClickEdit}
          />
        )}

        {hasPermission([PERMS.TasksAdmin]) && (
          <CloseCircle
            size={theme.size.sm}
            className={classes.clickable}
            onClick={() => {
              const action = () => {
                deleteRule(rule.id);
              };

              setTitle("ARE YOU SURE?");
              setAction(action);
              setReason(
                `Are you sure you want to delete this rule for ${
                  categories[rule.task_category_id]?.name || "Unknown Category"
                }?`
              );
              setSubtext("");
              setV2(true);
            }}
          />
        )}
      </div>

      {expanded && (
        <div className={classes.types}>
          {rule.task_type_ids.map((typeId) => (
            <div key={typeId}>{types[typeId]?.name || "Unknown Type"}</div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryRule;
